<template>
  <div id="v-date-time">
    <v-text-field
      ref="editor"
      v-model="displayDate"
      :label="label"
      :rules="rules"
      readonly
      required
      @click="modalDate = true"
    >
      <v-icon slot="prepend-inner" color="primary" @click="modalDate = true">
        mdi-calendar
      </v-icon>
      <v-icon slot="append" color="secondary" @click="modalTime = true">
        mdi-clock-time-eight-outline
      </v-icon>
    </v-text-field>

    <v-dialog
      ref="dialogDate"
      v-model="modalDate"
      :return-value.sync="model"
      width="unset"
    >
      <v-date-picker v-model="dateModel" scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalDate = false"> Cancel </v-btn>
        <v-btn text color="primary" @click="confirmDate()"> OK </v-btn>
      </v-date-picker>
    </v-dialog>
    <v-dialog
      ref="dialogTime"
      v-model="modalTime"
      :return-value.sync="model"
      width="unset"
    >
      <v-time-picker format="24hr" v-model="timeModel" scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalTime = false"> Cancel </v-btn>
        <v-btn text color="primary" @click="confirmTime()"> OK </v-btn>
      </v-time-picker>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "vdatetime",
  props: ["value", "label", "rules"],
  data() {
    return {
      modalDate: false,
      modalTime: false,
      displayDate: null,
      dateModel: null,
      timeModel: null,
      nameRules: [(v) => !!v || "Field is required"],
    };
  },
  mounted() {
    var d = new Date();

    if (this.value != null) d = new Date(this.value);

    this.timeModel = moment(d).format("HH:mm");
    this.dateModel = moment(d).format("YYYY-MM-DD");
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(model) {
        console.log(model);
      },
    },
  },
  methods: {
    // Confirm the datetime selection and close the popover
    confirmDate() {
      this.onUpdateDate();
      this.modalDate = false;
    },
    confirmTime() {
      this.onUpdateDate();
      this.modalTime = false;
    },

    // Format the date and trigger the input event
    onUpdateDate() {
      if (!this.dateModel || !this.timeModel) return false;

      this.displayDate =
        moment(this.dateModel).format("DD/MM/YYYY") + " " + this.timeModel;

      this.$emit("input", this.dateModel + " " + this.timeModel);
    },
  },
};
</script>